module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-statistics"
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "statistics-global"
  }, [_c('div', {
    staticClass: "panel-container panel-container--mobile"
  }, [_c('div', {
    staticClass: "panel bk-sent"
  }, [(!_vm.is_loading) ? _c('bk-sent', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-chart"
  }, [(!_vm.is_loading) ? _c('leads-chart', {
    attrs: {
      "start-date": _vm.queryParams.start_date,
      "end-date": _vm.queryParams.end_date,
      "leads-count": _vm.leads_count,
      "statistics": _vm.statistics,
      "trackings": _vm.trackings
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-classification"
  }, [(!_vm.is_loading) ? _c('leads-classification', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel bk-per-lead"
  }, [(!_vm.is_loading) ? _c('bk-per-lead', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-container panel-container--desktop"
  }, [_c('div', {
    staticClass: "column column-left"
  }, [_c('div', {
    staticClass: "panel bk-sent"
  }, [(!_vm.is_loading) ? _c('bk-sent', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-chart"
  }, [(!_vm.is_loading) ? _c('leads-chart', {
    attrs: {
      "start-date": _vm.queryParams.start_date,
      "end-date": _vm.queryParams.end_date,
      "leads-count": _vm.leads_count,
      "statistics": _vm.statistics,
      "trackings": _vm.trackings
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column-right"
  }, [_c('div', {
    staticClass: "panel leads-classification"
  }, [(!_vm.is_loading) ? _c('leads-classification', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel bk-per-lead"
  }, [(!_vm.is_loading) ? _c('bk-per-lead', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (!_vm.is_loading) ? _c('div', {
    staticClass: "grid title-grid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('statistics.latest_trackings')))]), _vm._v(" "), _c('router-link', {
    staticClass: "link full-link",
    attrs: {
      "to": {
        name: 'project_statistics_trackings',
        params: {
          id: _vm.id
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.see_full_tracking_history')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "icon yule-icon-chevron-right link short-link",
    attrs: {
      "to": {
        name: 'project_statistics_trackings',
        params: {
          id: _vm.id
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.trackings) ? _c('div', {
    staticClass: "statistics-trackings"
  }, [(!_vm.is_loading) ? _c('tracking-table', {
    attrs: {
      "date-format": "DD.MM.YYYY HH:mm",
      "project-id": _vm.id,
      "trackings": _vm.trackings.resources
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data')) + "\n  ")]), _vm._v(" "), (_vm.rankings && _vm.ranking_unable) ? _c('div', {
    staticClass: "statistics-ranking"
  }, [(!_vm.is_loading) ? _c('h3', [_vm._v(_vm._s(_vm.$t('statistics.lead_detectors_overview')))]) : _vm._e(), _vm._v(" "), (!_vm.is_loading) ? _c('ranking', {
    attrs: {
      "rankings": _vm.rankings
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed88f76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectStatistics.vue
// module id = 1904
// module chunks = 0